module.exports = __webpack_public_path__ + "images/2748d03049c28a068a8faa4ad63421ef-IMG_4483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4483.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4483.jpg
// module chunks = 0